import {useTranslation} from "react-i18next";
import {useContext, useEffect, useState} from "react";
import AppContext from "../../context/app/context";
import {useNavigate} from "react-router-dom";
import {useIsMount} from "../../utils/hooks/is-mount";
import styles from "./style.module.scss";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import {Button, Divider} from "antd";
import Can from "../../utils/rbac/can";
import {CAN_VIEW_HOME_PAGE} from "../../utils/rbac/permissions";
import {FileExcelOutlined, PlusOutlined} from "@ant-design/icons";
import PageHeader from "../../components/general/layout/page-header";
import SearchFilterCard from "../../components/general/filter-card";
import CategoryCampaignContext from "../../context/category-campaign/context";
import CategoryCampaignContextProvider from "../../context/category-campaign/provider";
import CategoryCampaignTable from "../../components/category-campaign/category-campaign-table";
import ExportToExcelModal from "../../components/general/excel/export-to-excel-modal";
import {columnsExportCityExcel, IExportCityExcel} from "../../models/city/request";
import TemplateExportExcel from "../../components/general/excel/expor-excel";

interface IProps {
    children?: React.ReactNode;
}

const CategoryCampaign: React.FC<IProps> = (props) => {
    const {t} = useTranslation();
    const {direction} = useContext(AppContext);
    const navigate = useNavigate();

    const [search, setSearch] = useState<string | undefined>(undefined);
    const [exportModalVisible, setExportModalVisible] = useState(false);

    const {actions, loading, query} = useContext(CategoryCampaignContext);
    const [isSortingEnabled, setIsSortingEnabled] = useState(false);
    const [loadingCat, setLoadingCat] = useState(false);

    useEffect(() => {
        actions.setSearch(search);
    }, [search]);

    const isMounted = useIsMount();
    useEffect(() => {
        !isMounted && actions.getData();
    }, [query, direction]);

    return (
        <div dir={direction} className={styles.container}>
            <PageHeader
                title={t("categories_campaigns")}
                extra={[
                    <RefreshBtn
                        key={0}
                        loading={loading.includes("list")}
                        onClick={() => actions.getData()}
                    >
                        {t("refresh")}
                    </RefreshBtn>,
                    <Divider key={1} type="vertical"/>,
                    <Can key={2} perform={CAN_VIEW_HOME_PAGE}>
                        <Button
                            type="primary"
                            onClick={() => {
                                navigate(`/categories_campaigns/create`);
                            }}
                            icon={<PlusOutlined/>}
                        >
                            {t("add_category_campaigns")}
                        </Button>
                        {/*<Divider key={1} type="vertical"/>*/}
                        {/*<Button*/}
                        {/*    type="primary"*/}
                        {/*    onClick={() => {*/}
                        {/*        setExportModalVisible(true);*/}
                        {/*    }}*/}
                        {/*    icon={<FileExcelOutlined/>}*/}
                        {/*>*/}
                        {/*    {t("export_to_excel")}*/}
                        {/*</Button>*/}
                        <Divider key={1} type="vertical"/>
                        <Button
                            loading = {loadingCat}
                            type="primary"
                            onClick={() => {
                                setIsSortingEnabled(!isSortingEnabled)
                                setLoadingCat(false)
                            }}
                        >
                            {isSortingEnabled ? t("disable_sorting") : t("enable_sorting")}
                        </Button>

                    </Can>,
                ]}
            />
            <SearchFilterCard
                formId="category-charity-filter"
                searchValue={search}
                setSearchValue={setSearch}
                onReset={() => {
                    actions.setQuery({
                        page: query?.page,
                        perPage: query?.perPage,
                    });
                }}
                resetLoading={loading.includes("list")}
                applyLoading={loading.includes("list")}
            >
            </SearchFilterCard>
            <CategoryCampaignTable isSortingEnabled={isSortingEnabled} setLoadingCat={setLoadingCat}/>
            <ExportToExcelModal
                id="export-category"
                title={t("export_to_excel")}
                visible={exportModalVisible}
                toggleVisible={setExportModalVisible}
                width="50vw"
                defaultValues={
                    {
                        id: false,
                        name: false,
                        note: false,
                    } as IExportCityExcel
                }
                loading={loading.includes("create")}
                onSubmit={async (columnsNames) => {
                    // await a(columnsNames);
                    await actions.exportExcel(columnsNames);
                    setExportModalVisible(false);
                }}
            >
                <TemplateExportExcel names={columnsExportCityExcel} />
            </ExportToExcelModal>
        </div>
    )
}

const CategoryCampaignPage = () => {
    return (
        <CategoryCampaignContextProvider>
            <CategoryCampaign/>
        </CategoryCampaignContextProvider>
    );
};
export default CategoryCampaignPage;